<template>
  <AppDropdown
    ref="appDropdown"
    :activeState="activeState"
    :cssClass="cssClass"
    :dropDownAbove="dropDownAbove"
    :fontSize="fontSize"
    :iconPath="iconPath"
    :title="dropDownTitle"
    @mouseleave="onLeave"
    @mouseover="onHover"
    @mousemove="trackPointer"
  >
    <DropDownSelectionRow
      v-for="option in options"
      :key="option.value"
      :belongsToId="option.belongsToId"
      :cssClass="cssClass"
      :disabled="option.disabled"
      :selectedID="selectedID"
      :title="option.name"
      :value="option.value"
      tabindex="0"
      @keydown.enter="() => select(option.value, option.name, option.belongsToId)"
      @keydown.space="(event) => select(option.value, option.name, option.belongsToId, event, true)"
      @selected="select"
    />
  </AppDropdown>
  <TooltipGeneral
    v-if="showDisabledHoverExplanationText"
    :title="$t('general__data__data-missing')"
    :pointerEvent="trackPointerEvent"
  />
</template>

<script>
import AppDropdown from './AppDropdown.vue'
import DropDownSelectionRow from './DropDownSelectionRow.vue'
import TooltipGeneral from '@/components/general/TooltipGeneral.vue'
export default {
  name: 'DropDownSelection',
  components: {
    AppDropdown,
    DropDownSelectionRow,
    TooltipGeneral
  },
  props: {
    activeState: {
      type: String,
      default: 'inactive',
      validator: (value) => {
        return ['inactive', 'active'].indexOf(value) !== -1
      }
    },
    options: {
      type: Array,
      required: true,
      validator: (prop) => {
        return prop.length > 0
      }
    },
    dropDownAbove: {
      // Used for displaying dropdown above content, instead of pushing down content below
      type: Boolean,
      default: false
    },
    dropDownTitle: {
      type: String,
      default: ''
    },
    selectedID: {
      validator: (value) => typeof value === 'string' || value == null,
      required: true
    },
    cssClass: {
      type: String,
      default: ''
    },
    iconPath: {
      type: String,
      default: ''
    },
    fontSize: {
      type: String,
      default: ''
    }
  },
  emits: ['selected'],
  data() {
    return {
      showDisabledHoverExplanationText: false,
      trackPointerEvent: null
    }
  },
  methods: {
    closeDropdown() {
      this.$refs.appDropdown.closeDropdown()
    },
    onHover(event) {
      this.showDisabledHoverExplanationText = false
      if (event.target.className.includes('disabled')) this.showDisabledHoverExplanationText = true
    },
    onLeave() {
      this.showDisabledHoverExplanationText = false
      this.trackPointerEvent = null
    },
    select(value, name, belongsToId, event, preventDefault) {
      if (event && preventDefault) event.preventDefault() // Prevent space bar scrolling
      this.$emit('selected', value, name, belongsToId)
    },
    trackPointer(event) {
      if (!this.showDisabledHoverExplanationText) return
      this.trackPointerEvent = event
    }
  }
}
</script>
